import React from "react";
import styled from "styled-components";
const dashboardBothImage = "./assets/img/web_mobile_preview.webp";

const ExploreMoreSection = () => {
  return (
    <Section id={'explore-more-section'}>
      <Content>
        <Left>
          <Label>HOW MAJURA WORKS</Label>
          <Title>Customize to Your Need. Pay for What You Use</Title>
        </Left>
        <Right>
          <Description>
            Skip the bloated bundles. With Majura, pick your tools, customize your flow, and only pay for the work. Our AI actually completes nothing more, nothing wasted
          </Description>
          <GlowingButton href="/under-maintenance">Explore More</GlowingButton>
        </Right>
      </Content>

      <ImageContainer>
        <InnerCard>
          <a
            href={dashboardBothImage}
            target="_blank"
            rel="noopener noreferrer"
          >
            <MobileDashboard src={dashboardBothImage} alt="Mobile Dashboard" />
          </a>
        </InnerCard>
      </ImageContainer>
    </Section>
  );
};

const Section = styled.section`
  background: linear-gradient(180deg, #0b1c75 0%, #0d2c99 100%);
  color: white;
  position: relative;
  overflow: hidden;
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1440px;
  margin: 0 auto;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 6rem 4rem 0rem;

  @media (max-width: 1025px) {
    flex-direction: column;
    padding: 5rem 4rem 0rem;
  }

  @media (max-width: 767px) {
    padding: 2rem 2.5rem 0rem;
  }
`;

const Left = styled.div`
  max-width: 50%;

  @media (max-width: 1025px) {
    max-width: max-content;
  }
`;

const Label = styled.p`
  color: white;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 1px;

  @media (max-width: 1025px) {
    font-weight: 500;
  }
`;

const Title = styled.h2`
  color: white;
  font-size: 2.5rem;
  font-weight: 700;
  margin-top: 1rem;

  @media (max-width: 1025px) {
    font-weight: 500;
    margin: 1rem 0rem 0.5rem;
    font-size: 2rem;
  }
`;

const Right = styled.div`
  max-width: 40%;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  @media (max-width: 1025px) {
    max-width: 100%;
  }
`;

const Description = styled.p`
  font-size: 1.2rem;
  line-height: 1.6;
  text-align: left;
  color: white;

  @media (max-width: 767px) {
    font-size: 1rem;
  }
`;

const GlowingButton = styled.a`
  background: transparent;
  color: #3edcff;
  border: 2px solid #3edcff;
  border-radius: 30px;
  padding: 0.75rem 2rem;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  position: relative;
  width: fit-content;
  z-index: 1;
  box-shadow: 0 0 10px #3edcff, 0 0 30px #9d8cff;
  margin-top: 0rem;
`;

const MobileDashboard = styled.img`
  width: auto;
  height: 100%;
  border-radius: 20px;

  @media (max-width: 767px) {
    display: flex;
  }
`;

const ImageContainer = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  margin-top: 8rem;
  justify-content: center;
  position: relative;
  // padding: 0 4rem;

  @media (max-width: 1025px) {
    padding: 0;
    width: fit-content;
    margin-top: 5rem;
  }

  @media (max-width: 767px) {
    align-items: center;
    padding: 0;
    width: 100%;
  }
`;

const InnerCard = styled.div`
  border-radius: 20px;
  overflow: hidden;
  width: fit-content;
`;

export default ExploreMoreSection;
